module.exports = __webpack_public_path__ + "static/media/value-proposition-curation@2x.2ec8c4dd.png";